"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.toCamelCase = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/* eslint no-return-assign: "error" */

/**
 * Converts a route description into camel case. This camelcase value is used as
 * the key in a tree of paths.
 * @param {string} pathName The description of the route
 * @package
 */
var toCamelCase = function toCamelCase(pathName) {
  return pathName.split(" ").map(function (nameFragment, index) {
    return index === 0 ? nameFragment.toLowerCase() : nameFragment.charAt(0).toUpperCase() + nameFragment.slice(1);
  }).join("");
};
/**
 * Extracts path names from a tree of routes. These path names can then be used
 * within a front-end app as keys, rather than having to use the full URL itself.
 *
 * @example
 * <Link to={paths.services.index}>Services</Link>
 * <Link to={paths.home}>Home</Link>
 *
 * @param {Routes} routes A tree of routes.
 * @returns {Paths} A tree of paths
 *
 * @example
 * {
 * home: "/",
 * aboutUs: "/about-us",
 * services: {
 *  index: "/services",
 *   buy: "/services/buy",
 *  sell: {
 *    index: "/services/sell",
 *    sellItem: "/services/sell/:id"
 *  }
 * }
 * }
 *
 * @package
 */


exports.toCamelCase = toCamelCase;

var extractPaths = function extractPaths(routes) {
  var pathMap = {};
  routes.forEach(function (route) {
    if (route.children) {
      return pathMap[toCamelCase(route.description)] = (0, _extends2["default"])({
        index: route.path
      }, extractPaths(route.children));
    }

    return pathMap[toCamelCase(route.description)] = route.path;
  });
  return pathMap;
};

var _default = extractPaths;
exports["default"] = _default;